import { render } from "./LeadDetailsPage.vue?vue&type=template&id=cd661a1e&ts=true"
import script from "./LeadDetailsPage.vue?vue&type=script&lang=ts"
export * from "./LeadDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__